import { Theme, keyframes } from '@mui/material';
import { TemplateSettings } from '../../store/interfaces';
import { makeStyles } from 'tss-react/mui';

const barChartLoaderEffect = keyframes`
0% { height: 75px },
33.33% { height: 105px },
66.66% { height: 45px },
100% { height: 75px }
`;

const BarChartLoaderStyles = makeStyles<TemplateSettings>()((theme: Theme, props) => ({
  barChartLoaderWrapper: {
    width: '150px',
    height: '150px',
    display: 'inline-block',
    overflow: 'hidden',
    background: 'transparent',
  },
  barChartLoader: {
    width: '100%',
    height: '100%',
    position: 'relative',
    transform: 'translateZ(0) scale(1)',
    backfaceVisibility: 'hidden',
    transformOrigin: '150px 150px!important',
    '& > div': {
      transform: 'rotate(180deg)',
      width: '100%',
      height: '100%',
    },
    '& > div > div': {
      position: 'absolute',
      width: '20px',
      height: '60px',
      top: '20px',
      animation: `${barChartLoaderEffect} 1s cubic-bezier(0.5, 0, 0.5, 1) infinite`,
    },
    '& > div > div:nth-child(1)': {
      left: '20px',
      backgroundColor: props.page.buttonStyle2.fillColor,
      borderColor: props.page.buttonStyle2.outlineColor,
      border: '2px solid',
      animationDelay: '-0.47s',
    },
    '& > div > div:nth-child(2)': {
      left: '50px',
      backgroundColor: props.page.buttonStyle1.fillColor,
      borderColor: props.page.buttonStyle1.outlineColor,
      border: '2px solid',
      animationDelay: '-0.24s',
    },
    '& > div > div:nth-child(3)': {
      left: '80px',
      backgroundColor: props.page.buttonStyle2.fillColor,
      borderColor: props.page.buttonStyle2.outlineColor,
      border: '2px solid',
      animationDelay: '-0.7s',
    },
    '& > div > div:nth-child(4)': {
      left: '110px',
      backgroundColor: props.page.buttonStyle1.fillColor,
      borderColor: props.page.buttonStyle1.outlineColor,
      border: '2px solid',
      animationDelay: '-1.2s',
    },
  },
}));

export default BarChartLoaderStyles;
